import { render, staticRenderFns } from "./CurrencyFormModal.vue?vue&type=template&id=6c53fa30"
import script from "./CurrencyFormModal.vue?vue&type=script&lang=js"
export * from "./CurrencyFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports